import { Navbar } from "../Navigation/Navbar";
import {Space, Card, Badge, Typography} from "antd";
import React from "react";


export const PremiumFeatureDisabled = ({ bg_image, feature_name, info_text, show_navbar=true, backgroundPosition='center', backgroundSize='cover' }) => {

    return (
        <>
        {
            show_navbar ? <Navbar /> : <></>
        }
        <div style={{
        backgroundImage: `url(${bg_image})`,
        height: '90vh',
        backgroundSize: backgroundSize,
        backgroundPosition: backgroundPosition,
        backgroundRepeat: 'no-repeat',
        border: '1px solid white',
        }}>
            
        <Space>
        <Badge.Ribbon text={<b>ELITE</b>} color="blue">
        <Card 
            style={{ 
            marginTop: '2.5rem', 
            justifySelf: 'center',
            border: '1px solid #A9A9A9',
            }}
            >
            <Typography.Title level={2}>Welcome to {feature_name}!</Typography.Title>
            <Typography.Text>{info_text}</Typography.Text>
        </Card>
        </Badge.Ribbon>
        </Space>
        </div>
        </>
    )

};
